import type { TRuleWithTheme } from '@ackee/fela';

export const extendContainer = (() => ({
    display: 'grid',
    overflow: 'visible',
    '@media (max-width: 570px)': {
        '& .testimonialTxt': {
            display: 'none',
        },
        '& .testimonialQuotes': {
            display: 'none',
        },
    },

})) as TRuleWithTheme;

export const extendImgContainer = (() => ({
    position: 'relative',
    placeSelf: 'center stretch',
    marginTop: '2rem',

    tablet: {
        marginTop: 'unset',
    },
    overflow: 'unset',
    '&:hover .dropshadow': {
        opacity: '100%!important',
    },
})) as TRuleWithTheme;


export const extendBottomRightImgContainer = (() => ({
    position: 'relative',
    placeSelf: 'center stretch',
    marginTop: '2rem',
    alignSelf: 'flex-start',
    tablet: {
        marginTop: 'unset',
    },
    overflow: 'unset',
    '&:hover .dropshadow': {
        opacity: '100%!important',
    },
})) as TRuleWithTheme;

export const extendLinkTitle: TRuleWithTheme = ({ theme: { colors } }) => ({
    color: colors.blue,
});

export const extendSectionContainer = (() => ({
    '@media (max-width: 570px)': {
        width: 'calc(100vw - 3rem)',
    },
    overflow: 'unset',
})) as TRuleWithTheme;

export const overflowContainer = (() => ({
    position: 'relative',
    overflow: 'unset',
    '&:hover .dropshadow': {
        opacity: '100%!important',
    },
})) as TRuleWithTheme;

export const titleContainer: TRuleWithTheme = () => ({
    display: 'flex',
    justifyContent: 'space-between',
});

const fadeInOut = {
    '0%': { opacity: 0 },
    '30%': { opacity: 1 },
    '95%': { opacity: 1 },
    '100%': { opacity: 0 },
};

const fadeIn = {
    '0%': { opacity: 0 },
    '10%': { opacity: 1 },
};

export const dropShadow: TRuleWithTheme = () => ({
    position: 'absolute',
    top: -30,
    left: 5,
    zIndex: -1000,
    width: '105%',
    aspectRatio: '1/1',
    opacity: '0',
});

export const topLeftContainer: TRuleWithTheme = () => ({
    marginTop: '0.5rem',
    width: 'auto',
    aspectRatio: '624/513',
    position: 'relative',

    '& .testimonial': {
        minWidth: 'calc(100% - 3.5rem)',
        color: 'white',
        '@media (min-width: 1024px) and (max-width: 1202px)': {
            fontSize: '0.875rem',
            gap: '0.5rem',
        },
        '@media (max-width: 570px)': {
            fontSize: '0.85rem',
            '& div[class^=Profile]': {
                display: 'none',
            },
        },
    },

    '& ~.dropShadowGif': {
        display: 'none',
    },
    '&:hover ~ .dropShadowGif': {
        top: '418px',
        left: '-26px',
        opacity: 1,
        display: 'block',

        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        imageRendering: 'pixelated',
        width: '110%',
        '@media screen and (max-width: 1023px)': {
            display: 'none',
        },
        '@media (min-width: 1024px) and (max-width: 1299px)': {
            top: '466px',
            left: '-26px',
        },
        '@media (min-width: 1300px) and (max-width: 1650px)': {
            top: '447px',
            left: '-26px',
        },
    },
});

export const topRightContainer: TRuleWithTheme = () => ({
    width: 'auto',
    aspectRatio: '514 / 605',
    placeSelf: 'center stretch',
    position: 'relative',

    '& .testimonial': {
        minWidth: '90%',
        '@media (min-width: 1024px) and (max-width: 1202px)': {
            fontSize: '0.875rem',
            gap: '0.5rem!important',
        },
    },
    '& ~.dropShadowGif': {
        display: 'none',
    },
    '&:hover ~ .dropShadowGif': {
       top: '-132px', 
       left: '13px',
        opacity: 1,
        display: 'block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        imageRendering: 'pixelated',
        width: '110%',

        '@media screen and (max-width: 1023px)': {
            display: 'none',
        },
        '@media (min-width: 1024px) and (max-width: 1299px)': {
            top: '-69px',
            left: '0px',
        },
        '@media (min-width: 1300px) and (max-width: 1650px)': {
            top: '-100px',
            left: '2px',
        },
    },
});

export const timelineContainer: TRuleWithTheme = () => ({
    width: 'auto',
    aspectRatio: '1284/617',
    margin: '3rem 0rem 2rem',
    position: 'relative',

    '& .testimonial': {
        minWidth: 'calc(100% - 3.5rem)',
        '@media (max-width: 740px)': {
            fontSize: '0.875rem',
            gap: '0.5rem!important',

            '& div[class^=Profile]': {
                display: 'none',
            },
        },
        '@media (max-width: 570px)': {
            width: '100%',
            '& span[class^=Text_text_]': {
                display: 'none',
            },
        },
    },
    '@media (max-width: 570px)': {
        width: 'calc(100vw - 3rem)',
    },

    '& ~.dropShadowGif': {
        display: 'none',
    },
    '&:hover .dropShadowGif': {
        top: '-107px',
        left: '-16px',
        opacity: 1,
        display: 'block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        imageRendering: 'pixelated',

        '@media screen and (max-width: 1023px)': {
            display: 'none',
        },
        '@media (min-width: 1024px) and (max-width: 1299px)': {
            top: '-69px',
            left: '-13px',
        },
        '@media (min-width: 1300px) and (max-width: 1650px)': {
            top: '-91px',
            left: '-16px',
        },
    }
});

export const bottomLeftContainer: TRuleWithTheme = () => ({
    marginTop: '12rem',
    width: 'auto',
    aspectRatio: '753 / 514',
    placeSelf: 'center stretch',
    position: 'relative',
    '& .testimonial': {
        minWidth: '90%'
    },
    '@media screen and (max-width: 1023px)': {
        marginTop: '1.5rem',
    },

    '& ~.dropShadowGif': {
        display: 'none',
    },
    '&:hover .dropShadowGif': {
        top: '-124px',
        left: '24px',
        opacity: 1,
        display: 'block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        imageRendering: 'pixelated',
        width: '110%',

        '@media screen and (max-width: 1023px)': {
            display: 'none',
        },
        '@media (min-width: 1024px) and (max-width: 1299px)': {
            top: '-90px',
            left: '17px',
        },
        '@media (min-width: 1300px) and (max-width: 1650px)': {
            top: '-104px',
            left: '20px',
        },
    },
});

export const bottomRightContainer: TRuleWithTheme = () => ({
    marginTop: '1.5rem',
    width: 'auto',
    aspectRatio: '624/513',
    position: 'relative',

    '& ~.dropShadowGif': {
        display: 'none',
    },
    '&:hover .dropShadowGif': {
        top: '-123px',
        left: '37px',
        opacity: 1,
        display: 'block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        imageRendering: 'pixelated',
        width: '110%',

        '@media screen and (max-width: 1023px)': {
            display: 'none',
        },
        '@media (min-width: 1024px) and (max-width: 1299px)': {
            top: '-68px',
            left: '15px',
        },
        '@media (min-width: 1300px) and (max-width: 1650px)': {
            top: '-103px',
            left: '23px',
        },
    },

    '& .testimonial': {
        minWidth: '90%'
    },

    '&:hover .dropShadow': {
        top: '-60px',
        left: '78px',
        opacity: 0,
        transition: 'opacity 0.1s ease-in-out',
        transitionDelay: '0.6s',
    },
});

export const mb0: TRuleWithTheme = () => ({
    marginBottom: 0,
});

export const sectionTitle: TRuleWithTheme = () => ({
    marginBottom: '5rem',
    width: '65%',
    tabletLarge: {
        minHeight: '225px',
        marginBottom: '17rem',
    },
});

export const imgTimeline: TRuleWithTheme = () => ({
    margin: '2rem 0',
});

export const bottomSection: TRuleWithTheme = () => ({
    marginTop: '7.5rem',
    display: 'flex',
    alignItems: 'end',
    '@media (max-width: 570px)': {
        width: 'calc(100vw - 3rem)',
    },
    '& span': {
        display: 'flex',
        height: '1.625rem',
        width: 'fit-content',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        marginLeft: '1rem',
    },
    '& a': {
        color: '#00F',
        fontSize: '1.25rem',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '1.5rem' /* 120% */,
        letterSpacing: '0.0085rem',
        textDecorationThickness: '2px',
        textUnderlineOffset: '0.175rem',
    },
});
